export default __webpack_public_path__ + "static/media/delivery.fc642d80.svg";